var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"view-qr","hide-footer":"","title":"QR Code"}},[_c('div',{staticClass:"text-center"},[(_vm.getQrCode)?_c('div',[_c('QRcode',{attrs:{"value":_vm.getQrCode,"size":200,"level":"H"}})],1):_c('div',[_vm._v("No QR Code")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }